const actions = {
  // Action Types
  GET_COMPANY_STATUS_REPORT: 'GET_COMPANY_STATUS_REPORT',
  GET_COMPANY_AGENT_REPORT: 'GET_COMPANY_AGENT_REPORT',
  GET_COMPANY_TIME_REPORT: 'GET_COMPANY_TIME_REPORT',
  GET_COMPANY_CONTACT_REPORT: 'GET_COMPANY_CONTACT_REPORT',
  GET_COMPANY_CONTRACT_REPORT: 'GET_COMPANY_CONTRACT_REPORT',
  GET_OVERVIEW_REPORT: 'GET_OVERVIEW_REPORT',
  GET_TICKET_STATUS_REPORT: 'GET_TICKET_STATUS_REPORT',
  GET_TICKET_TAG_REPORT: 'GET_TICKET_TAG_REPORT',

  SET_COMPANY_STATUS_REPORT: 'SET_COMPANY_STATUS_REPORT',
  SET_COMPANY_AGENT_REPORT: 'SET_COMPANY_AGENT_REPORT',
  SET_COMPANY_TIME_REPORT: 'SET_COMPANY_TIME_REPORT',
  SET_COMPANY_CONTACT_REPORT: 'SET_COMPANY_CONTACT_REPORT',
  SET_COMPANY_CONTRACT_REPORT: 'SET_COMPANY_CONTRACT_REPORT',
  SET_OVERVIEW_REPORT: 'SET_OVERVIEW_REPORT',
  SET_TICKET_STATUS_REPORT: 'SET_TICKET_STATUS_REPORT',
  SET_TICKET_TAG_REPORT: 'SET_TICKET_TAG_REPORT',

  SET_REPORT_ERROR: 'SET_REPORT_ERROR',
  RESET_REPORT_STATUS: 'RESET_REPORT_STATUS',

  // Action Creators
  getCompanyStatusReport: (params) => ({
    type: actions.GET_COMPANY_STATUS_REPORT,
    payload: params
  }),

  getCompanyAgentReport: () => ({
    type: actions.GET_COMPANY_AGENT_REPORT
  }),

  getCompanyTimeReport: (params) => ({
    type: actions.GET_COMPANY_TIME_REPORT,
    payload: params
  }),

  getCompanyContactReport: () => ({
    type: actions.GET_COMPANY_CONTACT_REPORT
  }),

  getCompanyContractReport: () => ({
    type: actions.GET_COMPANY_CONTRACT_REPORT
  }),

  getOverviewReport: () => ({
    type: actions.GET_OVERVIEW_REPORT
  }),

  getTicketStatusReport: () => ({
    type: actions.GET_TICKET_STATUS_REPORT
  }),

  getTicketTagReport: () => ({
    type: actions.GET_TICKET_TAG_REPORT
  }),

  // Reducer Actions
  setCompanyStatusReport: (data) => ({
    type: actions.SET_COMPANY_STATUS_REPORT,
    payload: data
  }),

  setCompanyAgentReport: (data) => ({
    type: actions.SET_COMPANY_AGENT_REPORT,
    payload: data
  }),

  setCompanyTimeReport: (data) => ({
    type: actions.SET_COMPANY_TIME_REPORT,
    payload: data
  }),

  setCompanyContactReport: (data) => ({
    type: actions.SET_COMPANY_CONTACT_REPORT,
    payload: data
  }),

  setCompanyContractReport: (data) => ({
    type: actions.SET_COMPANY_CONTRACT_REPORT,
    payload: data
  }),

  setOverviewReport: (data) => ({
    type: actions.SET_OVERVIEW_REPORT,
    payload: data
  }),

  setTicketStatusReport: (data) => ({
    type: actions.SET_TICKET_STATUS_REPORT,
    payload: data
  }),

  setTicketTagReport: (data) => ({
    type: actions.SET_TICKET_TAG_REPORT,
    payload: data
  }),

  setReportError: (error) => ({
    type: actions.SET_REPORT_ERROR,
    payload: error
  }),

  resetReportStatus: () => ({
    type: actions.RESET_REPORT_STATUS
  })
};

export default actions; 